export class InterviewAnswer {
  key: string;
  value: string;
}
